import React, { useState } from 'react';
import { FaCar, FaTools, FaSprayCan, FaUserShield } from 'react-icons/fa';

const servicesData = [
  {
    id: 'rental',
    icon: <FaCar className="text-4xl text-white group-hover:text-amber-400 transition-colors" />,
    title: 'Instant Car Rental',
    description: 'Find and book the perfect car for your next adventure in minutes. Our extensive fleet offers a variety of models to fit every need and budget.',
    image: '/assets/bmw-3.png',
  },
  {
    id: 'maintenance',
    icon: <FaTools className="text-4xl text-white group-hover:text-amber-400 transition-colors" />,
    title: 'Professional Maintenance',
    description: 'All our vehicles are meticulously inspected and maintained by certified professionals to ensure your safety and comfort on the road.',
    image: '/assets/mercedes-1.png',
  },
  {
    id: 'detailing',
    icon: <FaSprayCan className="text-4xl text-white group-hover:text-amber-400 transition-colors" />,
    title: 'Premium Car Detailing',
    description: 'We offer premium car detailing services to keep your rental looking and feeling brand new. A clean car is a happy car.',
    image: '/assets/toyota-2.png',
  },
  {
    id: 'support',
    icon: <FaUserShield className="text-4xl text-white group-hover:text-amber-400 transition-colors" />,
    title: '24/7 Roadside Assistance',
    description: 'Rest easy knowing our dedicated support team is available around the clock to assist you with any issues you may encounter during your journey.',
    image: '/assets/ford-1.png',
  },
];

const DynamicServices = () => {
  const [activeService, setActiveService] = useState(servicesData[0]);

  return (
    <section className="bg-slate-950 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-2">
            Our Comprehensive <span className="text-amber-400">Services</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side: Interactive Service List */}
          <div className="space-y-8 p-4">
            {servicesData.map((service) => (
              <div
                key={service.id}
                onMouseEnter={() => setActiveService(service)}
                className="group flex items-start space-x-6 cursor-pointer transform transition-all duration-300 hover:scale-105 p-6 rounded-lg border-2 border-transparent hover:border-amber-400"
              >
                <div className="p-4 bg-slate-800 rounded-full flex-shrink-0">
                  {service.icon}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white group-hover:text-amber-400 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-400 mt-1">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side: Dynamic Content Panel */}
          <div className="relative overflow-hidden rounded-lg shadow-2xl h-96">
            <img 
              key={activeService.id} // Key prop to force re-render and animation
              src={activeService.image} 
              alt={activeService.title} 
              className="absolute w-full h-full object-cover service-fade-in" 
            />
            <div className="absolute inset-0 bg-black bg-opacity-70 flex flex-col justify-end p-8 text-white service-fade-in">
              <h3 className="text-2xl font-bold mb-2 text-amber-400">{activeService.title}</h3>
              <p className="text-slate-400 text-sm">{activeService.description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicServices;